import React, { createContext, useState, useContext, ReactNode, Dispatch, SetStateAction } from 'react';

// Define the types for the context value
interface SelectedContextType {
  selectedOption: string | null;
  setSelectedOption: Dispatch<SetStateAction<string | null>>;
}

// Create the context with a default value
const SelectedContext = createContext<SelectedContextType>({
  selectedOption: null,
  setSelectedOption: () => {},
});

// Custom hook to use the SelectedContext
export const useSelected = () => {
  const context = useContext(SelectedContext);
  if (!context) {
    throw new Error('useSelected must be used within a SelectedProvider');
  }
  return context;
};

// Define the props type for the provider
interface SelectedProviderProps {
  children: ReactNode;
}

// Context provider component
export const SelectedProvider: React.FC<SelectedProviderProps> = ({ children }) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  return (
    <SelectedContext.Provider value={{ selectedOption, setSelectedOption }}>
      {children}
    </SelectedContext.Provider>
  );
};
